import LocalStorageService from '@/services/LocalStorageService'

export default {
  methods: {
    saveToStorage (formData) {
      LocalStorageService.saveFormData(formData)
    },

    loadFromStorage () {
      return LocalStorageService.getFormData()
    },

    clearStorage () {
      LocalStorageService.clearFormData()
    },
  },
} 


// WEBPACK FOOTER //
// ./src/mixins/FormStorageMixin.js